import React from 'react';
import './PaymentFailureScreen.scss';
import Navbar from '../../../CommonComponents/Navbar/Navbar';
import { Typography } from '@mui/material';
import Lottie from 'lottie-react';
import failureLottie from '../../../../assets/lottie_animations/failure-lottie.json';
import { useNavigate } from 'react-router-dom';

interface PaymentFailureScreenProps {
    errorMessage?: string;
    errorCode?: string;
}

const PaymentFailureScreen: React.FC<PaymentFailureScreenProps> = ({
    errorMessage = "Server sent unreadable data",
    errorCode = "123456789",
}) => {
    const navigate = useNavigate();

    const onRetryClicked = () => {
        navigate('/my-messages')
    }

    return (
        <div className="payment-failure-screen">
            <Navbar useScrollVersion={true}></Navbar>
            <div className="payment-failure-container">
                <div className="content">
                    <div className="error-container">
                        <Lottie className="failure-lottie" animationData={failureLottie} loop={true}></Lottie>
                        <Typography className='order-failure-heading' variant='h6'>Error: <b>{errorCode}</b> - {errorMessage} </Typography>
                        <Typography className='order-failure-error' variant='h4' fontWeight={600}>Order Failed</Typography>
                        <button className="retry-button" onClick={onRetryClicked}>RETRY</button>
                    </div>
                </div>
                <div className="contact">
                    <Typography variant='h6' fontWeight={200} style={{color:'#000000', marginTop:'8px', textAlign:'center'}}>For further queries or help, please check <b>FAQ</b> or contact us
                    <br></br>By clicking <b>Contact Us</b> button in options </Typography>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailureScreen;
